import { cn } from '@/shared/lib/utils/classnames';

interface ContentPreviewProps {
  /** 배경 이미지 URL */
  backgroundImage: string;
  /** 오버레이 타이틀 */
  overlayText: string;
  /** 높이 (기본값: 240px) */
  height?: number;
  /** 추가 클래스 */
  className?: string;
}

/**
 * ContentPreview - Figma Store 2.0 Content Container 패턴
 *
 * 배경 이미지 위에 그라데이션 오버레이와 타이틀을 표시하는 컴포넌트
 * Agent 상세 카드의 미리보기 영역에 사용
 */
export function ContentPreview({
  backgroundImage,
  overlayText,
  height = 240,
  className,
}: ContentPreviewProps) {
  return (
    <div className={cn('relative overflow-hidden rounded-lg pl-10', className)} style={{ height }}>
      {/* 배경 이미지 */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${backgroundImage})` }}
      />

      {/* 그라데이션 오버레이 */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent" />

      {/* 타이틀 오버레이 */}
      <div className="w-full h-full flex items-center">
        <h3 className="text-2xl font-bold text-white leading-[1.2] drop-shadow-lg whitespace-pre-wrap">
          {overlayText.replace(/\\n/g, '\n')}
        </h3>
      </div>
    </div>
  );
}
